<template>
    <svg :fill="colorx" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 460 500" xml:space="preserve">
        <g>
            <g>
                <g>
                    <path d="M395,0H95C83.972,0,75,8.972,75,20v450c0,11.028,8.972,20,20,20h300c11.028,0,20-8.972,20-20V20
                        C415,8.972,406.028,0,395,0z M95,20h300v215h-15V50c0-5.523-4.477-10-10-10H120c-5.523,0-10,4.477-10,10v185H95V20z M360,60v175
                        H130V60H360z M360,470H130V295h230V470z M395.001,470H380V285c0-5.523-4.477-10-10-10H120c-5.523,0-10,4.477-10,10v185H95V255
                        h300.001V470z"/>
                    <path d="M200,205h90c5.523,0,10-4.477,10-10v-35h-20v25h-70v-25h-20v35C190,200.523,194.477,205,200,205z"/>
                    <rect x="215" y="75" width="60" height="20"/>
                    <rect x="195" y="110" width="100" height="20"/>
                    <path d="M200,440h90c5.523,0,10-4.477,10-10v-35h-20v25h-70v-25h-20v35C190,435.523,194.477,440,200,440z"/>
                    <rect x="215" y="310" width="60" height="20"/>
                    <rect x="195" y="345" width="100" height="20"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
  data: () => ({

  }),
  props: {
    colorx: {
      type: String,
      default: '#89899B'
    }
  }
}
</script>

<style lang="css">
</style>


// WEBPACK FOOTER //
// src/components/shared/icons/LockerIcon.vue